import { Injectable } from '@angular/core';
import { UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { EntryConfigInterface } from '@ptl/forms';

@Injectable({
  providedIn: 'root'
})
/**
 * Scope of forms seems to be weird ( validity, validators, values, errors, etc )
 * This seeks to have a single location to refer to collect form errors to establish
 * validity within the PageIndividualOnExchangePlanEnrollmentComponent
 * - this only exists because I couldn't figure out how to be validate form components within
 *   a forms as json flow
 */
export class PageIndividualOnExchangePlanEnrollmentService {

  componentErrors: ValidationErrors = {};

  constructor() { }

  recordError(error: { [componentName: string]: any }, errorKey: string) {
    this.componentErrors[errorKey] = error[errorKey];
  }

  removeError(componentName: string) {
    delete this.componentErrors[componentName];
  }

  hasErrors() {
    return Object.keys(this.componentErrors).length > 0;
  }

  /**
   * Use key from .json file to report internal form's validity
   * Set named error on parent, clear when appropriate
   */
  reportValidity(form: UntypedFormGroup, entry: EntryConfigInterface) {
    const errorKey = entry.formControlAttributes.formControlName;
    const error: ValidationErrors = {};

    if (form.invalid) {
      error[errorKey] = true;
      this.recordError(error, errorKey);
    } else {
      this.removeError(errorKey);
    }
  }

}
